import DbConfig from '../../../config/DbConfig.js'
import {rtrim} from '../../functions/Common.js'

// 获取本地群列表
export function getListByCustomWxId(c_open_id,lastId,param,callback){
	let db = DbConfig.connect()
	let sql = 'select c.*,cus.id as custom_id,cus.open_id as custom_open_id,cus.wx_name as custom_name from yswl_cluster as c inner join yswl_cluster_member as cm on c.id = cm.cluster_id inner join yswl_custom as cus on cus.open_id=cm.open_id where'
	if(lastId != 0){
		sql += ' c.id < ' + lastId + ' and'
	}
	if(c_open_id !== ''){
		sql += ' cm.open_id = "' + c_open_id + '" and'
	}
	if(param.keyword !== undefined && param.keyword !== ''){
		sql += ' c.cluster_name like "%' + param.keyword + '%" and'
	}
	sql = rtrim(rtrim(sql,'where'),'and')
	sql += ' group by c.id order by c.id desc limit 20'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

/**
 * 根据群id，客服微信号，获取群的详细信息
 * @param {Object} id 群id
 * @param {Object} w_open_id 客服微信id
 * @param {Object} callback
 */
export function getClusterDetailById(id,w_open_id,callback){
	let db = DbConfig.connect()
	let sql = 'select c.id as fans_id,c.wechat_cluster_id as fans_wx_id,c.cluster_name as fans_wx_name,c.cluster_photo as fans_wx_photo,cus.id as custom_id,cus.open_id as custom_wx_id,cus.wx_name as custom_wx_name,cus.wx_photo as custom_wx_photo,cus.phone_id,cus.identity,cus.is_online from yswl_cluster as c '
	sql += 'inner join yswl_cluster_member as cm on cm.cluster_id = c.id '
	sql += 'inner join yswl_custom as cus on cm.open_id = cus.open_id '
	sql += 'where c.id = ' + id + ' and cm.open_id= "'+ w_open_id + '"'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 根据群id，获取群信息
export function getClusterById(id,callback){
	let db = DbConfig.connect()
	let sql = 'select * from yswl_cluster where id = '+ id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 保存群信息
export function saveCluster(data,callback){
	let db = DbConfig.connect()
	if(data.cluster_id === undefined){
		callback(false)
		return
	}
	let id = data.cluster_id
	let cluster_name = data.cluster_name
	let cluster_photo = data.cluster_photo
	let wechat_cluster_id = data.wechat_cluster_id
	let owner_id = data.with_account_id !== undefined ?  data.with_account_id : 0
	let sql = 'insert into yswl_cluster(id,cluster_name,cluster_photo,wechat_cluster_id,owner_id) values(?,?,?,?,?)'
	db.transaction(tx=>{
		tx.executeSql(sql,[id,cluster_name,cluster_photo,wechat_cluster_id,owner_id],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 保存群成员信息
export function saveClusterMember(id,clusterId,friendsOpenId,callback){
	let db = DbConfig.connect()
	let sql = 'insert into yswl_cluster_member(id,cluster_id,open_id) values(?,?,?)'
	db.transaction(tx=>{
		tx.executeSql(sql,[id,clusterId,friendsOpenId],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 保存群成员信息
export function saveClusterMembers(menbers,callback){
	let db = DbConfig.connect()
	let sql = 'insert into yswl_cluster_member(id,cluster_id,open_id) values'
	for (let i = 0; i < menbers.length; i++) {
		sql += '('+menbers[i].id+','+menbers[i].cluster_id+',"'+menbers[i].friends_open_id+'")'
		if(i < menbers.length - 1){
			sql += ','
		}
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 修改群名称
export function updateClusterName(cluster_id,cluster_name,callback){
	let db = DbConfig.connect()
	if(cluster_id === undefined){
		callback(false)
		return
	}
	let sql = 'update yswl_cluster set cluster_name = ? where id = ?'
	db.transaction(tx=>{
		tx.executeSql(sql,[cluster_name,cluster_id],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 删除群
export function deleteCluster(id,callback){
	let db = DbConfig.connect()
	let sql = 'delete from yswl_cluster where id = ' + id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 删除群成员，根据群id
export function deleteClusterMemberByClusterId(cluster_id,callback){
	let db = DbConfig.connect()
	let sql = 'delete from yswl_cluster_member where cluster_id = ' + cluster_id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			callback(false)
		})
	})
}